"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _AudienceTargetingGroup = _interopRequireDefault(require("AudienceTargetingUIComponents/AudienceTargetingGroup"));

var _Filters = require("AudienceTargetingUIComponents/constants/Filters");

var _FilterRecord = _interopRequireDefault(require("AudienceTargetingUIComponents/constants/FilterRecord"));

var _filterUtils = require("AudienceTargetingUIComponents/utils/filterUtils");

var _createUUID = _interopRequireDefault(require("./utils/createUUID"));

var _Operators = _interopRequireDefault(require("./constants/Operators"));

/* eslint-disable react/no-unused-prop-types */
var AudienceTargetingRenderer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AudienceTargetingRenderer, _Component);
  (0, _createClass2.default)(AudienceTargetingRenderer, null, [{
    key: "propTypes",
    get: function get() {
      return {
        audience: _react.PropTypes.object.isRequired,
        filterList: _react.PropTypes.array.isRequired,
        handleChange: _react.PropTypes.func.isRequired,
        hasScope: _react.PropTypes.bool.isRequired,
        labelConfig: _react.PropTypes.object,
        upgradeConfig: _react.PropTypes.object.isRequired,
        updateAudience: _react.PropTypes.func.isRequired,
        usageTracking: _react.PropTypes.func
      };
    }
  }, {
    key: "defaultPropTypes",
    get: function get() {
      return {
        labelConfig: {}
      };
    }
  }]);

  function AudienceTargetingRenderer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AudienceTargetingRenderer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AudienceTargetingRenderer).call(this, props));
    _this.addFilter = _this.addFilter.bind((0, _assertThisInitialized2.default)(_this));
    _this.addSegment = _this.addSegment.bind((0, _assertThisInitialized2.default)(_this));
    _this.getShowFilterOptions = _this.getShowFilterOptions.bind((0, _assertThisInitialized2.default)(_this));
    _this.getWhiteListedFilters = _this.getWhiteListedFilters.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeFilter = _this.removeFilter.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateFilter = _this.updateFilter.bind((0, _assertThisInitialized2.default)(_this));
    _this.addHideGroup = _this.addHideGroup.bind((0, _assertThisInitialized2.default)(_this));
    _this.addShowGroup = _this.addShowGroup.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AudienceTargetingRenderer, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "addFilter",
    value: function addFilter(groupId, isShow, isURL) {
      var _this$props = this.props,
          audience = _this$props.audience,
          updateAudience = _this$props.updateAudience,
          usageTracking = _this$props.usageTracking;
      var audienceFilter = (0, _immutable.fromJS)(audience.filter);
      var type = isShow ? 'OR' : 'NOT';
      var filterPath = (0, _filterUtils.getFilterPath)(audienceFilter, type, groupId, 0);
      var groupValuesPath = filterPath.slice(0, filterPath.length - 1);
      var filter = new _FilterRecord.default({
        type: isURL ? 'URL' : null
      });
      var values = audienceFilter.getIn(groupValuesPath);
      var newValues = values.push(filter);
      var newAudienceFilter = audienceFilter.setIn(groupValuesPath, newValues);
      audience.filter = newAudienceFilter;
      if (usageTracking) usageTracking('audience-targeting-added-filter');
      updateAudience(audience);
    }
  }, {
    key: "addHideGroup",
    value: function addHideGroup(groupId) {
      var _this$props2 = this.props,
          audience = _this$props2.audience,
          updateAudience = _this$props2.updateAudience,
          usageTracking = _this$props2.usageTracking;
      var filter = (0, _immutable.fromJS)(audience.filter);
      var showGroup = filter.get('values').find(function (group) {
        return group.get('groupId') === groupId;
      });
      var showGroupValues = (0, _filterUtils.getOrValues)(showGroup);
      var values = filter.get('values');
      var isUrl = showGroupValues.getIn([0, 'type']) === 'URL' || showGroupValues.getIn([0, 'type']) === 'QUERY_PARAM';
      var updatedValues = values.push((0, _filterUtils.getDefaultHideFilter)(groupId, isUrl));
      var updatedFilter = filter.set('values', updatedValues);
      audience.filter = updatedFilter;
      if (usageTracking) usageTracking('audience-targeting-added-hide-group');
      updateAudience(audience, false, true);
    }
  }, {
    key: "addShowGroup",
    value: function addShowGroup(groupId, newFilter, isURL) {
      var _this$props3 = this.props,
          audience = _this$props3.audience,
          updateAudience = _this$props3.updateAudience,
          usageTracking = _this$props3.usageTracking;
      var filter = (0, _immutable.fromJS)(audience.filter);
      var values = filter.get('values');
      var newShowGroup = isURL ? (0, _filterUtils.getDefaultUrlGroupFilter)(groupId) : (0, _filterUtils.getDefaultBlankFilter)(groupId);
      var normalizedNewfilter = isURL ? newFilter.set('type', 'URL') : newFilter;
      newShowGroup = newShowGroup.set('values', new _immutable.List([normalizedNewfilter]));
      var updatedValues = values.push(newShowGroup);
      var updatedFilter = filter.set('values', updatedValues);
      audience.filter = updatedFilter;
      if (usageTracking) usageTracking('audience-targeting-added-show-group');
      updateAudience(audience, false, true);
    }
  }, {
    key: "addSegment",
    value: function addSegment() {
      var _this$props4 = this.props,
          audience = _this$props4.audience,
          updateAudience = _this$props4.updateAudience,
          usageTracking = _this$props4.usageTracking;
      var filter = (0, _immutable.fromJS)(audience.filter);
      var values = filter.get('values');
      var groupId = (0, _createUUID.default)();
      var updatedValues = values.push((0, _filterUtils.getDefaultBlankFilter)(groupId));
      var updatedFilter = filter.set('values', updatedValues);
      audience.filter = updatedFilter;
      if (usageTracking) usageTracking('audience-targeting-added-segment');
      updateAudience(audience);
    }
  }, {
    key: "getWhiteListedFilters",
    value: function getWhiteListedFilters() {
      var filterList = this.props.filterList;
      return Object.keys(_Filters.FILTERS).reduce(function (acc, filter) {
        if (filterList.indexOf(filter) > -1) {
          acc[filter] = _Filters.FILTERS[filter];
        }

        return acc;
      }, {});
    }
  }, {
    key: "getShowFilterOptions",
    value: function getShowFilterOptions() {
      // make sure we only allow the white listed filters
      var whiteListedFilters = this.getWhiteListedFilters();
      return (0, _extends2.default)({}, whiteListedFilters, {
        URL: (0, _extends2.default)({}, _Filters.FILTERS.URL, {
          operators: ['ALL'].concat((0, _toConsumableArray2.default)(_Filters.FILTERS.URL.operators))
        })
      });
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(index, groupId, isShow) {
      var _this$props5 = this.props,
          audience = _this$props5.audience,
          updateAudience = _this$props5.updateAudience,
          usageTracking = _this$props5.usageTracking;
      var audienceFilter = (0, _immutable.fromJS)(audience.filter);
      var type = isShow ? 'OR' : 'NOT';
      var filterPath = (0, _filterUtils.getFilterPath)(audienceFilter, type, groupId, index);
      var groupPath = filterPath.slice(0, filterPath.length - 2);
      var notGroupPath = filterPath.slice(0, filterPath.length - 4);
      var group = audienceFilter.getIn(groupPath);
      var isLastItem = group.get('values').size === 1;
      if (isLastItem && !isShow) groupPath = notGroupPath;
      var newAudienceFilter = isLastItem ? audienceFilter.removeIn(groupPath) : audienceFilter.removeIn(filterPath);
      audience.filter = newAudienceFilter;
      var values;
      if (usageTracking) usageTracking('audience-targeting-removed-filter');

      if (!(0, _filterUtils.hasUrlFilter)(newAudienceFilter)) {
        values = newAudienceFilter.get('values');
        values = values.splice(0, 0, (0, _filterUtils.getDefaultUrlGroupFilter)());
        newAudienceFilter = newAudienceFilter.setIn(['values'], values);
        audience.filter = newAudienceFilter;
      }

      updateAudience(audience);

      if (!(0, _filterUtils.hasNotURLFilter)(newAudienceFilter)) {
        this.addSegment();
      }
    }
  }, {
    key: "updateFilter",
    value: function updateFilter(index, groupId, property, value, isShow) {
      var isURL = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var _this$props6 = this.props,
          audience = _this$props6.audience,
          updateAudience = _this$props6.updateAudience,
          _this$props6$usageTra = _this$props6.usageTracking,
          usageTracking = _this$props6$usageTra === void 0 ? function () {} : _this$props6$usageTra;
      var audienceFilter = (0, _immutable.fromJS)(audience.filter);
      var type = isShow ? 'OR' : 'NOT';
      var filterPath = (0, _filterUtils.getFilterPath)(audienceFilter, type, groupId, index);
      var filter = audienceFilter.getIn(filterPath);
      var newFilter = filter.set(property, value);

      if (property === 'type') {
        newFilter = newFilter.set('operator', _Filters.FILTERS[value].operators[0]);
        newFilter = newFilter.set('values', _Filters.FILTERS[value].defaultValue);
        usageTracking('audience-targeting-new-filter-selected', {
          filterSelected: _Filters.FILTERS[value].key
        });
      }

      if (value === _Operators.default.ALL) {
        newFilter = newFilter.set('values', '');
      }

      if (isShow && filterPath.indexOf(-1) > 0) {
        this.addShowGroup(groupId, newFilter, isURL);
        return;
      }

      var newAudienceFilter = audienceFilter.setIn(filterPath, newFilter);
      audience.filter = newAudienceFilter;
      var isType = property === 'type' && newFilter.get('type') !== 'CONTACT';
      updateAudience(audience, isType);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          audience = _this$props7.audience,
          handleChange = _this$props7.handleChange,
          hasScope = _this$props7.hasScope,
          labelConfig = _this$props7.labelConfig,
          upgradeConfig = _this$props7.upgradeConfig;
      var filter = audience.filter;

      if (!filter) {
        return null;
      }

      var filterGroups = (0, _filterUtils.getFilterGroups)(filter);
      return _react.default.createElement("div", {
        className: "m-bottom-4"
      }, _react.default.createElement(_AudienceTargetingGroup.default, {
        addFilter: this.addFilter,
        addSegment: this.addSegment,
        addHideGroup: this.addHideGroup,
        filterGroups: filterGroups,
        hasScope: hasScope,
        showFilterOptions: this.getShowFilterOptions(),
        hideFilterOptions: this.getWhiteListedFilters(),
        labelConfig: labelConfig,
        onChange: handleChange,
        onBlur: handleChange,
        removeFilter: this.removeFilter,
        upgradeConfig: upgradeConfig,
        updateFilter: this.updateFilter
      }));
    }
  }]);
  return AudienceTargetingRenderer;
}(_react.Component);

exports.default = AudienceTargetingRenderer;
module.exports = exports.default;